import { Box } from '@mui/material';
import {
    SignalCellularAltRounded,
    LanguageRounded,
    VisibilityOffRounded,
    PasswordRounded,
    CallMissedOutgoingRounded,
    DashboardRounded,
    LoopRounded,
} from '@mui/icons-material';
import FeatureRow from './FeatureRow';

const Features = () => {
    return (
        <Box> 
            <FeatureRow 
                desc={
                    <>Indefinite validity – a shortened link without an expiration date <br/> that will always remain valid.</>
                }
                image={
                    <span style={{fontSize: '5rem'}}>&infin;</span>
                }
                isFirst={true}
            />
            <FeatureRow 
                reverse={true}
                desc={
                    <>Control how many times a link can be used by setting the <i>Maximum Redirects</i> field during shortening. The link deactivates once the specified number of successful redirects is reached.</>
                }
                image={
                    <span style={{fontSize: '3rem'}}>&#8815; 3</span>
                }
            />
            <FeatureRow 
                desc={
                    <>Secure your shortened link with passcode protection. <br/> Users will be required to enter a passcode before being redirected <br/> to the destination.</>
                }
                image={
                    <PasswordRounded style={{ fontSize: '5rem' }}/>
                }
            />
            <FeatureRow 
                reverse={true}
                desc={
                    <>DeadLink – a link that remains in a perpetual loading state. By managing this option, you can control the accessibility of your link.</>
                }
                image={
                    <LoopRounded style={{ fontSize: '3rem' }}/>
                }
            />
            <FeatureRow 
                desc={
                    <>Would you like to hide the source link once the shortened link expires, <br/> or make it visible to others? Use the <i>Revealable</i> option to control this behavior.</>
                }
                image={
                    <VisibilityOffRounded style={{ fontSize: '3rem' }}/>
                }
            />
            <FeatureRow 
                reverse={true}
                desc={
                    <>Track every redirect made through your shortened link. See which redirects were successful or failed. View detailed information such as client IP, operating system, browser and the exact time when each redirect occurred.</>
                }
                image={
                    <CallMissedOutgoingRounded style={{ fontSize: '3rem' }}/>
                }
            />
             <FeatureRow 
                desc={
                    <>View your created conversions and redirect statistics <br/> to visualize link usage and monitor performance.</>
                }
                image={
                    <SignalCellularAltRounded style={{ fontSize: '3rem' }}/>
                }
            />
            <FeatureRow 
                reverse={true}
                desc={
                    <>Easily search and filter your shortened links in the Dashboard <br/> to quickly find the one you need.</>
                }
                image={
                    <DashboardRounded style={{ fontSize: '3rem' }}/>
                }
            />
            <FeatureRow 
                desc={
                    <>Review all domains you've used in your shortened links in one place <br/> to track which ones are used most frequently.</>
                }
                image={
                    <LanguageRounded style={{ fontSize: '3rem' }}/>
                }
            />
        </Box>
    );
}

export default Features;